import { render, staticRenderFns } from "./DebtProvidersTable.vue?vue&type=template&id=5cecfd03&scoped=true"
import script from "./DebtProvidersTable.vue?vue&type=script&lang=js"
export * from "./DebtProvidersTable.vue?vue&type=script&lang=js"
import style0 from "./DebtProvidersTable.vue?vue&type=style&index=0&id=5cecfd03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cecfd03",
  null
  
)

export default component.exports